//
// helpers/str-hash.js -- JS implementation of Java's hashcode()
//                     -- See: http://stackoverflow.com/a/7616484/196312
//                     -- May not be suitable for very long strings (> ~20,000 chars)
//

export default function(str) {
  let hash = 0
  for (let i=0, len=str.length; i < len; ++i) {
    let chr = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32 bit integer
  }
  return hash.toString();
}
